import * as React from "react";
import classnames from "classnames";
import { PopupModal } from "../../../../PopupModal/v3/components/PopupModal/PopupModal.js";
/* empty css                       */
const ToolTipPopUpModal = ({ className, toolTip, isPhone, ...rest }) => {
  const image = isPhone ? toolTip?.image?.mobile : toolTip?.image?.original;
  return /* @__PURE__ */ React.createElement(
    PopupModal,
    {
      ...rest,
      className: classnames("tool-tip-popup-modal", className),
      title: toolTip?.title ?? "",
      showIcon: true
    },
    toolTip && /* @__PURE__ */ React.createElement(React.Fragment, null, toolTip.image && /* @__PURE__ */ React.createElement(
      "img",
      {
        className: "tool-tip-popup-modal__image",
        src: image?.url,
        alt: toolTip.image.description ?? void 0
      }
    ), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "tool-tip-popup-modal__content",
        dangerouslySetInnerHTML: { __html: toolTip.description.value }
      }
    ))
  );
};
export {
  ToolTipPopUpModal,
  ToolTipPopUpModal as default
};
//# sourceMappingURL=ToolTipPopUpModal.js.map
